import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentTypeService {

  private apiUrl = environment.apiBaseUrl + '/api/';

  constructor(private http: HttpClient) { }

  getAllDocumentTypes(langCode: string): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}document-types`);
    }

    return this.http.get(`${this.apiUrl}document-types?lang=${langCode}`);
  }

  getDocumentTypeById(id: number, langCode: string): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}document-types/${id}`);
    }

    return this.http.get(`${this.apiUrl}document-types/${id}?lang=${langCode}`);
  }

  create(request: any): Observable<any> {
    return this.http.post(`${this.apiUrl}document-types`, request);
  }

  update(id: number, request: any): Observable<any> {
    return this.http.put(`${this.apiUrl}document-types/${id}`, request);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}document-types/${id}`);
  }
}
